<template>
  <div class="contact-us">
    <section>
      <SectionHeader title="Contact us"></SectionHeader>
      <div class='common__section-body'>
        <div class='contact-us__address-map-container'>
          <div class='contact-us__address-container'>
            <h4>OFFICE ADDRESS :</h4>
            <p>#39/2-10, Kalyani Gardens,</p>
            <p>Industrial Estate, (N.R.Colony),</p>
            <p>P.O. BSK 1st Stage,</p>
            <p>Bengaluru - 560050</p>
            <h4>PHONE :</h4>
            <p>Ph: 080-2676-6824 | 080-2964-6824</p>
            <p>Krishna Nagaraj - +91 98450 61908</p>
            <p>C.K.V Murthy - +91 98450 61530,</p>
            <h4>EMAIL :</h4>
            <p>e-mail: technocomerz@yahoo.co.in</p>
          </div>
          <div class='conntact-us__map-container'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.5546400102953!2d77.56268191482165!3d12.936320890879035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3db550000001%3A0x62a9fde95c184868!2sTECHNOCOMERZ!5e0!3m2!1sen!2sin!4v1564686679616!5m2!1sen!2sin" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </section>
    <hr class='common__section-divider' />
    <section>
      <SectionHeader title="COMPANY’S GST CODE & OTHER CODES"></SectionHeader>
      <div class='common__section-body'>
        <ul class='contact-us__code-container'>
          <li class='contact-us__code-item'>GSTIN No. 29AADFT6289R1Z0</li>
          <li class='contact-us__code-item'>PAN No. AADFT6289R</li> 
          <li class='contact-us__code-item'>Company ESI Code: 53/10938/64</li>
          <li class='contact-us__code-item'>SAC Code: 998729</li>
          <li class='contact-us__code-item'>HSN Codes:
            <br>Transformer Oil - 27101990
            <br>SilicaGel - 38249025
            <br>SilicaGel Breather – 85049010</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
@import '../sass/_variables.scss';

.contact-us__address-map-container {
  display: flex;
  justify-content: space-between;
  margin: 20px;
  border-radius: 5px;
  box-shadow: 0px 2px 5px -1px rgba(0, 0, 0, 0.5);

  @media (max-width: $md-screen) {
    flex-direction: column;
    margin: 0;
  }
}

.contact-us__address-container {
  padding: 20px 30px;

  @media (max-width: $md-screen) {
    padding: 10px;

    h4, p {
      margin: 5px 0;
    }
  }
}

.conntact-us__map-container {
  iframe {
    height: 100%;

    @media (max-width: $md-screen) {
      width: 100%;
      height: 200px;
    }
  }
}

.contact-us__code-container {
  list-style: none;
  padding: 0;
}

.contact-us__code-item {
  padding: 15px 20px;
  margin: 20px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0px 2px 5px -1px rgba(0, 0, 0, 0.5);

  @media (max-width: $md-screen) {
    padding: 10px 15px;
    margin: 10px 5px;
  }
}
</style>

<script>
import SectionHeader from '@/components/sectionHeader.vue'

export default {
  name: 'contactUs',
  components: {
    SectionHeader
  },
  data: () => ({})
}
</script>







